import { Component, Vue, Prop as prop} from 'nuxt-property-decorator';
import Swiper from 'swiper';
import { OfferList } from '~/types/catalog';

@Component({
    components: {
        catalog: require('~/components/catalog/offer-horisontal-slider/').default,
    },
    fetchOnServer: false
})
export default class RecentViewList extends Vue {

    data: OfferList = null;

    async fetch() {
        const data = await this.$store.dispatch('catalog/GetRecentViewList');

        if (!data?.length) {
            this.data = null;
        } else {
            this.data = {
                id: 'recent',
                offers: data,
            }
        }
    }
}
